import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import { ProduktDTO } from "~app/common/models/produkt/ProduktDTO";
import { ProduktDeleteRequestDTO } from "~app/common/models/produkt/ProduktDeleteRequestDTO";
import { ProduktEditResponseDTO } from "~app/common/models/produkt/ProduktEditResponseDTO";
import { ProduktGrunddataResponseDTO } from "~app/common/models/produkt/ProduktGrunddataResponseDTO";
import { ProduktSearchRequestDTO } from "~app/common/models/produkt/ProduktSearchRequestDTO";
import { ProduktSearchResponseDTO } from "~app/common/models/produkt/ProduktSearchResponseDTO";
import { ProduktinstruktionSearchRequestDTO } from "~app/common/models/produkt/ProduktinstruktionSearchRequestDTO";
import { ProduktinstruktionSearchResponseDTO } from "~app/common/models/produkt/ProduktinstruktionSearchResponseDTO";
import { ProduktspecifikationDTO } from "~app/common/models/produkt/ProduktspecifikationDTO";
import { ApiClientService } from "~app/common/services/api-client.service";
import { ISearchViol3ProduktModel } from "./produkt-detail/produkt-details.models";

@Injectable({
    providedIn: "root"
})

export class ProduktService {
    private readonly apiClient = inject(ApiClientService);

    search(request: ProduktSearchRequestDTO): Observable<ProduktSearchResponseDTO> {
        return this.apiClient.post<ProduktSearchRequestDTO, ProduktSearchResponseDTO>("produkt/SearchForProdukt", request, true);
    }

    getProduktgrunddata(): Observable<ProduktGrunddataResponseDTO> {
        return this.apiClient.get<ProduktGrunddataResponseDTO>("produkt/GetProduktgrunddata", true);
    }

    getNewProdukt(): Observable<ProduktEditResponseDTO> {
        return this.apiClient.get<ProduktEditResponseDTO>("produkt/GetNewProdukt", true)
            .pipe(tap(this.ensureValidNewProdukt));
    }

    getProduktById(id: number): Observable<ProduktEditResponseDTO> {
        return this.apiClient.get<ProduktEditResponseDTO>(`Produkt/GetProduktById/${id}`, true);
    }

    getProduktspecifikationById(id: number): Observable<ProduktEditResponseDTO> {
        return this.apiClient.get<ProduktEditResponseDTO>(`produkt/GetProduktspecifikationById/${id}`, true);
    }

    saveProdukt(produkt: ProduktDTO, produktspecifikation: ProduktspecifikationDTO): Observable<ProduktEditResponseDTO> {
        return this.apiClient.post<any, ProduktEditResponseDTO>(
            `produkt/SaveProdukt`,
            { produkt: produkt,
                produktspecifikation: produktspecifikation },
            true);
    }

    deleteProduktById(deleteProdukt: ProduktDeleteRequestDTO): Observable<void> {
        return this.apiClient.post<ProduktDeleteRequestDTO, void>("produkt/DeleteProdukt", deleteProdukt, true);
    }

    copyProdukt(id: number, produktSpecId: number | null): Observable<ProduktEditResponseDTO> {
        return this.apiClient.post<any, ProduktEditResponseDTO>(
            "produkt/CopyProdukt/",

            { Id: id,
                produktSpecifikationId: produktSpecId },
            true);
    }

    copyProduktspecifikation(id: number): Observable<ProduktEditResponseDTO> {
        return this.apiClient.post<any, ProduktEditResponseDTO>(
            "produkt/CopyProduktspecifikation/",
            { produktSpecifikationId: id },
            true);
    }

    searchForProduktinstruktion(produktinstruktionSearchParamsModel: ProduktinstruktionSearchRequestDTO): Observable<ProduktinstruktionSearchResponseDTO> {
        return this.apiClient.post<any, ProduktinstruktionSearchResponseDTO>(
            "produkt/SearchForProduktinstruktion",
            produktinstruktionSearchParamsModel,
            true);
    }

    searchForViolId(query: string): Observable<ISearchViol3ProduktModel[]> {
        return this.apiClient.get<ISearchViol3ProduktModel[]>("produkt/SearchViol", false, {
            query: query
        });
    }

    downloadPinFile(puid: string, viol3: boolean): Observable<any> {
        return this.apiClient.getRaw(`Produkt/GetPinFile/?puid=${puid}&viol3=${viol3}`, true, { responseType: "blob" });
    }

    private ensureValidNewProdukt(response: ProduktEditResponseDTO): ProduktEditResponseDTO {
        response.produkt.produktspecifikationer = [];
        response.produkt.sortiment = [];
        response.produkt.tradslag = [];
        response.produkt.handelssortimentsgrupp = undefined;

        return response;
    }
}
